import ContactForm from "../../components/ContactForm/ContactForm";

const ContactPage = () => {
  return (
    <div className="container">
      <ContactForm />
    </div>
  );
};

export default ContactPage;
